import axios from 'axios';

export const ecnpjApi = axios.create({
  baseURL: `https://api.grupobfc.com.br/app-customer-facta/e-cnpj/`,
});
